import { makeStyles } from "tss-react/mui";

import { tableRowHeight } from "@shared/table/MinimalTableComponents";

export const useStyles = makeStyles()(() => ({
    tableWrapper: {
        display: "flex",
        flexDirection: "column",
        height: 420,
    },
    tableWrapperEmpty: {
        display: "flex",
        flexDirection: "column",
        height: tableRowHeight * 2 + 12,
    },
}));
